module.exports = __webpack_public_path__ + "static/media/SharpSansNo1-Book.37a4dec0.woff";